module.exports = "/_next/static/images/san-diego-fast-channel-description-image-black-letters-22d78bf5149ce9c04ec45209719f13a4.svg";